var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppGenericInput',_vm._b({attrs:{"label":_vm.label,"items":_vm.organisationalFunctions,"item-value":"id","item-text":"name","component-name":_vm.inputProps.componentName || 'v-select',"inherit-listeners":{
    blur: evt => _vm.$emit('blur', evt)
  }},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'AppGenericInput',_vm.inputProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }